export default "__VITE_ASSET__nOa6guPg__"